'use strict';

rolesController.$inject = [
	'$scope',
	'$q',
	'$uibModal',
	'$timeout',
	'dialogHelper',
	'roleService',
	'authService',
	'USER_CLAIMS',
	'ROLE_CLAIMS',
	'ROLE_CLAIM_DESCRIPTIONS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('rolesController', rolesController);

function rolesController(
	$scope,
	$q,
	$uibModal,
	$timeout,
	dialogHelper,
	roleService,
	authService,
	USER_CLAIMS,
	ROLE_CLAIMS,
	ROLE_CLAIM_DESCRIPTIONS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.busyPromise = $q.all([$scope.vm.loadRoles($scope.vm), LoadSiteClaims($scope.vm)]);

	function getViewModel() {
		// NOTE: modifying or adding the ClaimValue of any objects below may require a corresponding change in the enumeration RolefieldClaimType found in file SchoolLinq.Data\Enums\RoleClaimType.cs
		var fieldClaimsBackup = [
			// Fund Management

			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.DenyAccrueInvoicesOnSNPOs,
				ClaimValue: ROLE_CLAIMS.DenyAccrueInvoicesOnSNPOs,
				isField: true,
				Module: 'Fund Management',
				Page: 'Purchase Orders',
				Description: 'Cannot Accrue Invoices on School Nutrition Purchase Orders',
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Payable',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Payable',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Manage Requisitions',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementManageRequisitionsDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Manage Requisitions',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementPurchaseOrdersDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementPurchaseOrdersDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Manage Purchase Orders',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementPurchaseOrdersDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementPurchaseOrdersDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Manage Purchase Orders',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementVendorsDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementVendorsDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Payable Vendors',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementVendorsDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementVendorsDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Payable Vendors',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Journal Entries',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementJournalEntriesDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Journal Entries',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Receivable',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementAccountsReceivableDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Accounts Receivable',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementBankEntriesDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundManagementBankEntriesDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Cash Management Bank Entries',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundManagementBankEntriesDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundManagementBankEntriesDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Cash Management Bank Entries',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundReclassifyChecksDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundReclassifyChecksDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Reclassify Checks',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundReclassifyChecksDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundReclassifyChecksDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Reclassify Checks',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundCashCustomerAccountsReceivableDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundCashCustomerAccountsReceivableDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Cash Management Customers',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundCashReceiptsDocMgmtDelete,
				ClaimValue: ROLE_CLAIMS.FundCashReceiptsDocMgmtDelete,
				isField: true,
				Module: 'Fund Management',
				Page: 'Cash Management - Receipts',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtDeleteAccess,
			},
			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.FundCashReceiptsDocMgmtConfidential,
				ClaimValue: ROLE_CLAIMS.FundCashReceiptsDocMgmtConfidential,
				isField: true,
				Module: 'Fund Management',
				Page: 'Cash Management - Receipts',
				Description: ROLE_CLAIM_DESCRIPTIONS.DocMgmtConfidentialAccess,
			},

			// System Settings

			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.HideBankAccountNumber,
				ClaimValue: ROLE_CLAIMS.HideBankAccountNumber,
				isField: true,
				Module: 'System Settings',
				Page: 'Banking Info',
				Description: 'Hide Bank Account Numbers From User',
			},

			{
				ClaimSection: 'field',
				ClaimModule: 'field',
				ClaimPage: ROLE_CLAIMS.PrintChecksOverride,
				ClaimValue: ROLE_CLAIMS.PrintChecksOverride,
				isField: true,
				Module: 'System Settings',
				Page: 'Banking Info',
				Description: 'Display button to user to override check printing on bank details panel',
			},
		];

		var model = {
			roles: [],
			permissions: {},
			permissionsBackup: {},
			fieldClaimsBackup: fieldClaimsBackup,
			fieldClaims: angular.copy(fieldClaimsBackup),
			siteClaims: [],
			selectedRoleUsers: [],
			isGA: false,
			isEmployeeRole: false,
			selectedRole: null,
			selectedRoleBackup: null,
			filter: {
				search: '',
				propertyName: 'Name',
				reverse: false,
				showingView: 'list',
				tab: 'General',
				toRight: false,
				toLeft: false,
				users: {
					propertyName: 'Name',
					reverse: false,
					pageSize: 12,
					startIndex: 0,
				},
			},
			pageSize: 12,
			startIndex: 0,
			errors: null,
			busyMessage: BUSY_MESSAGE.Loading,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.system, 'Roles', 'user'),
		};

		function selectOption(model, option, module) {
			var updated = false;
			if (!_.isArray(module)) module = [module];
			switch (option) {
				case 'readOnly':
					_.forEach(module, function (item) {
						if (item.ReadOnly && item.access !== 'readOnly') {
							item.access = 'readOnly';
							updated = true;
						}
					});
					break;

				case 'viewEdit':
					_.forEach(module, function (item) {
						if (item.ViewEdit && item.access !== 'viewEdit') {
							item.access = 'viewEdit';
							updated = true;
						} else if (!item.ViewEdit && item.ReadOnly && item.access !== 'readOnly') {
							item.access = 'readOnly';
							updated = true;
						}
					});
					break;

				default:
					_.forEach(module, function (item) {
						if (item.access) {
							item.access = null;
							updated = true;
						}
					});
			}
			if (updated) {
				$scope.roleForm.$setDirty();
			}
		}

		function loadRoles(model) {
			return roleService.list().then(_.partial(finishedLoadingRoles, model));

			function finishedLoadingRoles(model, response) {
				if (response.data.isValid) {
					model.roles = response.data.roles;
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		function addRole(model) {
			model.filter.toRight = false;
			model.filter.toLeft = true;
			$timeout(function () {
				model.filter.showingView = 'role';
			}, 0);

			model.isEmployeeRole = false;
			model.selectedRole = {};
			model.filter.tab = 'General';
			model.selectedRoleBackup = angular.copy(model.selectedRole);
			model.setClaims();
		}

		function getRole(model, roleId) {
			return roleService.get(roleId).then(_.partial(finishedLoadingRole, model));

			function finishedLoadingRole(model, response) {
				if (response.data.isValid) {
					model.selectedRole = response.data.role;
					model.filter.tab = 'General';
					model.selectedRoleUsers = response.data.users;
					model.isGA = model.selectedRole.Name === USER_CLAIMS.globalAdmin;
					model.selectedRoleBackup = angular.copy(model.selectedRole);
					model.isEmployeeRole = false;

					model.setClaims();
					if (model.isEmployeeRole) {
						model.filter.tab = 'Users';
					}
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		function selectRole(model, roleId) {
			model.filter.toRight = false;
			model.filter.toLeft = true;
			$timeout(function () {
				model.filter.showingView = 'role';
			}, 0);

			$scope.busyPromise = $q.all([model.getRole(roleId)]);
		}

		function setClaims(model) {
			model.permissions = angular.copy(model.permissionsBackup);
			model.fieldClaims = angular.copy(model.fieldClaimsBackup);

			angular.forEach(model.selectedRole.IdentityRoleClaims, function (claim) {
				if (model.permissions[claim.ClaimSection]) {
					if (claim.isField) {
						var fieldClaim = _.findWhere(model.fieldClaims, {
							ClaimSection: claim.ClaimSection,
							ClaimModule: claim.ClaimModule,
							ClaimPage: claim.ClaimPage,
							ClaimValue: claim.ClaimValue,
						});
						if (fieldClaim) {
							fieldClaim.Selected = true;
						}
					} else {
						var permission = _.findWhere(model.permissions[claim.ClaimSection][claim.ClaimModule], { Page: claim.ClaimPage });
						if (permission) {
							permission.access = claim.ClaimValue;
						}
					}
				}
			});
		}

		function unSelectRole(model) {
			model.filter.toLeft = false;
			model.filter.toRight = true;
			$timeout(function () {
				model.filter.showingView = 'list';
			}, 0);
		}

		function sortBy(model, filter, propertyName) {
			filter.reverse = filter.propertyName === propertyName ? !filter.reverse : false;
			filter.propertyName = propertyName;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelChanges, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function formIsDirty(model) {
			return model.selectedRole && $scope.roleForm.$dirty;
		}

		function cancelChanges(model) {
			$scope.roleForm.$setPristine();
			$scope.roleForm.$setUntouched();
			$scope.roleForm.roleName.$setValidity('validateDuplicateRole', true);
			model.selectedRole = angular.copy(model.selectedRoleBackup);
			model.setClaims();
		}

		function saveChanges(model) {
			$scope.roleForm.$setSubmitted();
			if (model.isReadOnly || !$scope.roleForm.$valid) {
				return;
			}

			model.selectedRole.IdentityRoleClaims = [];
			angular.forEach(
				model.permissions,
				function (subSections, section) {
					angular.forEach(
						subSections,
						function (items, subSection) {
							angular.forEach(
								items,
								function (item) {
									if (item.access) {
										this.push({
											ClaimSection: section,
											ClaimModule: subSection,
											ClaimPage: item.Page,
											ClaimValue: item.access,
											isField: false,
										});
									}
								},
								this
							);
						},
						this
					);
				},
				model.selectedRole.IdentityRoleClaims
			);

			angular.forEach(
				model.fieldClaims,
				function (claim) {
					if (claim.Selected) {
						this.push({
							ClaimSection: claim.ClaimSection,
							ClaimModule: claim.ClaimModule,
							ClaimPage: claim.ClaimPage,
							ClaimValue: claim.ClaimValue,
							isField: claim.isField,
						});
					}
				},
				model.selectedRole.IdentityRoleClaims
			);

			model.busyMessage = BUSY_MESSAGE.Saving;
			if (model.selectedRole.Id) {
				$scope.busyPromise = roleService.update(model.selectedRole).then(_.partial(finishedSavingRole, model));
			} else {
				$scope.busyPromise = roleService.add(model.selectedRole).then(_.partial(finishedSavingRole, model));
			}

			function finishedSavingRole(model, response) {
				if (response.data.isValid) {
					$scope.roleForm.$setPristine();
					$scope.roleForm.$setUntouched();
					return $q.all([model.loadRoles(), model.selectRole(response.data.roleId)]);
				} else {
					model.errors = response.data.errors;
					return angular.noop;
				}
			}
		}

		function copyRole(model) {
			model.isGA = false;
			model.selectedRole.Id = null;
			model.selectedRole.Name = model.selectedRole.Name + ' - Copy';
			model.selectedRole.Users = [];
			model.selectedRoleBackup = {};
			model.filter.tab = 'General';
			$scope.roleForm.roleName.$setTouched();
			$scope.roleForm.$setDirty();
		}

		function deleteRole(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/system/role-deleteconfirm-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							angular.extend($scope, {
								back: function () {
									modalInstance.close();
								},
								delete: function () {
									$scope.deletingPromise = roleService
										.deleteRole(model.selectedRole.Id)
										.then(_.partial(finishedDeletingRole, model));

									function finishedDeletingRole(model, response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											model.errors = response.data.errors;
											modalInstance.close(false);
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (reLoad) {
					if (reLoad) {
						model.busyMessage = BUSY_MESSAGE.Deleting;
						$scope.busyPromise = $q.all([model.loadRoles()]).then(function () {
							model.unSelectRole();
						});
					}
				});
		}

		return angular.extend(model, {
			selectOption: _.partial(selectOption, model),
			loadRoles: _.partial(loadRoles, model),
			addRole: _.partial(addRole, model),
			getRole: _.partial(getRole, model),
			selectRole: _.partial(selectRole, model),
			setClaims: _.partial(setClaims, model),
			unSelectRole: _.partial(unSelectRole, model),
			sortBy: _.partial(sortBy, model),
			changeTab: _.partial(changeTab, model),
			formIsDirty: _.partial(formIsDirty, model),
			cancelChanges: _.partial(cancelChanges, model),
			saveChanges: _.partial(saveChanges, model),
			copyRole: _.partial(copyRole, model),
			deleteRole: _.partial(deleteRole, model),
		});
	}

	function LoadSiteClaims(model) {
		return roleService.listSiteClaims().then(_.partial(finishedLoadingSiteClaims, model));

		function finishedLoadingSiteClaims(model, response) {
			if (response.data.isValid) {
				model.siteClaims = response.data.siteClaims;
				//TODO: This should be changed in the API but its a pretty messy route to change. Used by authService as well
				model.siteClaims = model.siteClaims.filter((item) => !item.HideFromAccessPage);
				// SYSTEM SETTINGS
				model.systemPermission = _.where(model.siteClaims, {
					Section: 'system',
				});
				var systemUniq = _.uniq(model.systemPermission, function (item, key, Module) {
					return item.Module;
				});
				model.permissions['system'] = {};
				angular.forEach(systemUniq, function (module) {
					model.permissions.system[module.Module] = _.where(model.systemPermission, { Module: module.Module });
					model.permissions.system[module.Module] = _.sortBy(model.permissions.system[module.Module], 'Ordinal');
					var addHeaderItem = model.permissions.system[module.Module].length > 1;
					if (addHeaderItem) {
						// add the header row
						var headerItem = {
							headerItem: true,
							selectOption: model.selectOption,
							module: model.permissions.system[module.Module],
						};
						model.permissions.system[module.Module].unshift(headerItem);
					}
				});

				// SCHOOL BOOKKEEPING
				model.lsbPermission = _.where(model.siteClaims, { Section: 'lsb' });
				const lsbUniq = _.uniq(model.lsbPermission, function (item, key, Module) {
					return item.Module;
				});

				model.permissions['lsb'] = {};
				angular.forEach(lsbUniq, function (module) {
					model.permissions.lsb[module.Module] = _.where(model.lsbPermission, {
						Module: module.Module,
					});
					model.permissions.lsb[module.Module] = _.sortBy(model.permissions.lsb[module.Module], 'Ordinal');
					var addHeaderItem = model.permissions.lsb[module.Module].length > 1;
					if (addHeaderItem) {
						// add the header row
						var headerItem = {
							headerItem: true,
							selectOption: model.selectOption,
							module: model.permissions.lsb[module.Module],
						};
						model.permissions.lsb[module.Module].unshift(headerItem);
					}
				});

				// fields
				model.fieldPermission = _.where(model.siteClaims, { Section: 'field' });
				var fieldUniq = _.uniq(model.fieldPermission, function (item, key, Module) {
					return item.Module;
				});
				model.permissions['field'] = {};
				angular.forEach(fieldUniq, function (module) {
					model.permissions.field[module.Module] = _.where(model.fieldPermission, { Module: module.Module });
					model.permissions.field[module.Module] = _.sortBy(model.permissions.field[module.Module], 'Ordinal');
				});

				model.permissionsBackup = angular.copy(model.permissions);
			} else {
				model.errors = response.data.errors;
			}

			return angular.noop;
		}
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}

angular.module('schoolLinqApp').directive('validateDuplicateRole', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attr, ngModel) {
			ngModel.$parsers.unshift(function (value) {
				var Id = attr.validateDuplicateRole;

				var numberOfMatches = scope.vm.roles.filter(function (row) {
					return row.Name.toLowerCase().trim() === value.toLowerCase().trim() && row.Id !== Id;
				}).length;

				var isValid;
				if (numberOfMatches > 0) {
					isValid = false;
				} else {
					isValid = true;
				}

				ngModel.$setValidity('validateDuplicateRole', isValid);
				return isValid ? value : undefined;
			});
		},
	};
});
